import { createContext } from 'react';

/**
 * Stable context object. Must live in its own module so Vite HMR of
 * UscgMapContext.tsx cannot allocate a second createContext() while an older
 * Provider instance is still mounted.
 */
export const UscgMapContext = createContext<unknown>(undefined);
